export const parseLeaguePaginatedResponse = (data) => {
  if (Array.isArray(data)) {
    return {
      results: data,
      page: 0,
      totalPages: 1,
      pageSize: data.length,
      totalResults: data.length,
    };
  }

  if (data?.results) {
    return {
      results: data.results,
      page: data.page ?? 0,
      totalPages: data.totalPages ?? 1,
      pageSize: data.pageSize ?? data.results.length,
      totalResults: data.totalResults ?? data.results.length,
    };
  }

  if (data?.data && data?.current_page !== undefined) {
    return {
      results: data.data,
      page: Math.max(0, data.current_page - 1),
      totalPages: data.last_page ?? 1,
      pageSize: data.per_page ?? data.data.length,
      totalResults: data.total ?? data.data.length,
    };
  }

  return {
    results: [],
    page: 0,
    totalPages: 1,
    pageSize: 0,
    totalResults: 0,
  };
};

export const parseFractalPaginatedResponse = (data) => {
  const pagination = data?.meta?.pagination ?? {};

  return {
    results: data?.data ?? [],
    page: Math.max(0, (pagination.current_page ?? 1) - 1),
    totalPages: pagination.total_pages ?? 1,
    pageSize: pagination.per_page ?? 0,
    totalResults: pagination.total ?? 0,
  };
};
